// Audio normalization. Based on ReplayGain.
// http://wiki.hydrogenaud.io/index.php?title=ReplayGain_specification

// TODO: human perception based loudness filtering (IIR filters)

//require('promise-decode-audio-data');
import { Message } from 'element-ui';

/*export interface NormalizedPlayerInterface {
  play(clipUrl: string): Promise<void>;
  stop(): void;
  onended?: (event: Event) => void;
}

*/export default class NormalizedPlayer /*implements NormalizedPlayerInterface*/ {
  /*private audioCtx: AudioContext;
  private gainNode: GainNode;
  private bufSource?: AudioBufferSourceNode;
  onended?: (event: Event) => void;*/
  constructor(cb) {
    this.audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    this.gainNode = this.audioCtx.createGain();
    this.gainNode.gain.value = 1.0;
    this.gainNode.connect(this.audioCtx.destination);
    this.cb = cb;
    this.duration = 0;
    this.requestId = null;
    this.decodedData = null;
    this.offset = 0;
    this.recordCurrTime = 0; // 触发偏移时记录当时的当前时间
  }
  /**
   * 播放
   * @param {*} clipUrl 音频url
   * @param {*} offsetRatio 播放时偏移比例
   */
  async play(clipUrl/*: string*/, offsetRatio=0) {
    const res = await fetch(clipUrl);
    // if(res.status === 403) {
    //   Message.error('此音频地址已过有效期，请重新获取音频地址');
    //   this.cb({
    //     status: 'ended',
    //     currentTime: 0
    //   })
    //   return;
    // }
    const encodedBuf = await res.arrayBuffer();
    const decodedData = await this.audioCtx.decodeAudioData(encodedBuf);
    this.decodedData = decodedData;
    // The decoded audio samples live in decodedBuffer
    const decodedBuffer = decodedData.getChannelData(0);
    this.duration = decodedData.duration;
    console.log('duration', decodedData.duration)

    // Obtain one Root Mean Square (RMS) value for
    // each slice of 50ms length
    var sliceLen = Math.floor(decodedData.sampleRate * 0.05);
    var averages = [];
    var sum = 0.0;
    for (var i = 0; i < decodedBuffer.length; i++) {
      sum += decodedBuffer[i] ** 2;
      if (i % sliceLen === 0) {
        sum = Math.sqrt(sum / sliceLen);
        averages.push(sum);
        sum = 0;
      }
    }

    // Ascending sort of the averages array
    averages.sort(function(a, b) {
      return a - b;
    });

    // Take the average at the 95th percentile
    var a = averages[Math.floor(averages.length * 0.95)];

    var gain = 1.0 / a;

    // Perform some clamping
    gain = Math.max(gain, 0.02);
    gain = Math.min(gain, 500.0);

    // ReplayGain uses pink noise for this one one but we just take
    // some arbitrary value... we're no standard
    // Important is only that we don't output on levels
    // too different from other websites
    gain = gain / 10.0;

    this.gainNode.gain.value = gain;
    console.log("Playing with gain value", gain);
    this.playBuf(decodedData, offsetRatio);
  }
  /**
   * buffer 播放
   * @param {*} buf buffer
   * @param {*} offsetRatio 播放时偏移比例
   */
  /*private*/ playBuf(buf/*: AudioBuffer*/, offsetRatio=0) {
    if (this.bufSource) {
      this.bufSource.stop();
      this.bufSource = null;
    }
    // if (offsetRatio) {
      this.recordCurrTime = this.audioCtx.currentTime;
    // }
    this.bufSource = this.audioCtx.createBufferSource();
    // // 加载一个音频缓冲
    // // 这里需要先加载音频缓冲，可以是异步加载
    
    // // 设置音频处理事件的监听器
    // this.bufSource.addEventListener('audioprocess', function(event) {
    //   console.log('Audio is processing');
    // });
    this.bufSource.buffer = buf;
    this.bufSource.connect(this.gainNode);
    // this.bufSource.onended = this.onended;
    this.bufSource.onended = () => {
      console.log('end')
      this.offset = 0;
      this.recordCurrTime = 0;
      this.cb({
        status: 'ended',
        currentTime: 0
      })
    };
    this.offset = offsetRatio * this.duration;
    this.bufSource.start(0, this.offset);

    // 开始监听播放时间
    this.updatePlaybackTime();

    // // 为 source 节点添加 onaudioprocess 事件处理器
    // this.bufSource.onaudioprocess = function(e) {
    //   // e.playbackTime 就是当前的播放时间
    //   console.log('Current playback time: ' + e.playbackTime);
    // };
  }
  stop() {
    this.bufSource.stop();
  }
  pause() {
    let state = this.audioCtx.state;
    let status = null;
    // let currentTime = this.audioCtx.currentTime;
    if(state === 'running') {
      this.audioCtx.suspend().then(() => {
        cancelAnimationFrame(this.requestId);
        this.requestId = null;
        status = 'suspended';
      });
    } else if(state === 'suspended') {
      this.audioCtx.resume().then(() => {
        this.requestId = requestAnimationFrame(() => this.updatePlaybackTime());
        status = 'running';
      });
    }
    this.cb({
      status,
      // currentTime
    })
  }
  onlyPause() {
    this.audioCtx.suspend();
    cancelAnimationFrame(this.requestId);
    this.requestId = null;
  }
  /**
   * 偏移播放
   * @param {*} offsetRatio  偏移播放比例
   */
  offsetPlay(offsetRatio) {
    console.log('offset')
    this.bufSource.stop();
    this.bufSource.onended = null;
    this.playBuf(this.decodedData, offsetRatio);
    this.audioCtx.resume();
  }
  close() {
    cancelAnimationFrame(this.requestId);
    this.audioCtx.close();
  }
  updatePlaybackTime() {
    let currentTime = this.audioCtx.currentTime;
    let showTime = currentTime;
    console.log('播放时间:', currentTime);
    // console.log('state', this.audioCtx.state)
    // console.log('duration:', this.duration);
    showTime = this.offset + (currentTime - this.recordCurrTime)
    this.cb({
      status: 'running',
      currentTime: showTime
    })
    this.requestId = requestAnimationFrame(() => this.updatePlaybackTime());
    if(showTime >= this.duration) {
      cancelAnimationFrame(this.requestId);
      this.requestId = null;
    }
  }
}

//console.log("Normalizer loaded for page ", window.location.href);

// function scanPage() {
// 	//console.log("checking for audio items");
// 	const list = document.getElementsByTagName("audio");
// 	for (item of list) {
// 		if (item.muted === true) {
// 			continue;
// 		}
// 		console.log("Normalizing audio item", item);
// 		item.muted = true;
// 		item.addEventListener("play", async () => {
// 			var player = new NormalizedPlayer();
// 			item.normalized_player = player;
// 			await player.play(item.src);
// 		});
// 		item.addEventListener("pause", async () => {
// 			//console.log("Paused");
// 			//item.normalized_player.close();
// 		});
// 		/*item.addEventListener("ended", function () {
// 			console.log("Ended");
// 		});*/
// 	}
// }

// var observer = new MutationObserver(function(mutations) {
// 	scanPage();
// });

// var config = { attributes: false, subtree: true, childList: true };

// observer.observe(document.body, config);

// window.onload = scanPage;
// window.onpopstate = scanPage;

// const normalize = new NormalizedPlayer()
// export default normalize